import type { Settings } from '@il-colpo/shared/settings';

/** True when the operating system asks for reduced motion. */
export function systemPrefersReducedMotion(): boolean {
  return typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/** The setting wins; `null` means "follow the system". */
export function isReducedMotion(
  settings: Settings,
  systemReduced = systemPrefersReducedMotion(),
): boolean {
  return settings.accessibility.reduceMotion ?? systemReduced;
}

/**
 * Mirrors settings into attributes and custom properties on `<html>` so that CSS (and
 * only CSS) reacts to accessibility and scale settings.
 */
export function applySettingsToDocument(
  settings: Settings,
  root: HTMLElement = document.documentElement,
  systemReduced = systemPrefersReducedMotion(),
): void {
  root.lang = settings.language;
  root.dataset['contrast'] = settings.accessibility.highContrast ? 'high' : 'normal';
  root.dataset['text'] = settings.accessibility.largeText ? 'large' : 'normal';
  root.dataset['motion'] = isReducedMotion(settings, systemReduced) ? 'reduce' : 'full';
  root.dataset['colorblind'] = settings.accessibility.colorblind ? 'on' : 'off';
  root.dataset['handed'] = settings.accessibility.leftHanded ? 'left' : 'right';
  root.dataset['blueprint'] = settings.game.blueprintTheme;
  root.style.setProperty('--ui-scale', String(settings.uiScale));
  root.style.setProperty('--anim-speed', String(settings.game.animationSpeed));
}
